import { randomLong } from './random';

const FB_SUBDOMAIN_IDX = 1;

export function buildFbcCookie(fbclid: string, ts: number): string {
  return `fb.${FB_SUBDOMAIN_IDX}.${ts}.${fbclid}`;
}

export function generateFbpCookie(ts: number): string {
  return `fb.${FB_SUBDOMAIN_IDX}.${ts}.${randomLong()}`;
}
